import React from 'react';

import Audio1 from '../image/audio1.jpeg';
import Audio2 from '../image/eardrrr.jpg';
import Audio3 from '../image/ear5.jpg';
import { Link } from "react-router-dom";
import FAQData from "./Faq";
import AboutDoctor from './../../AboutDoctor';

const BestServices = () => {
  return (
    <>
      <section className="myringoplasty-section">
      <style>
        {`
        section {
    position: relative;
    padding: 15px 0px !important;
}`}
      </style>
        <div className="container pq-section pq-style-1">
          <h2 className="section-title pq-section-title text-center">
            What is Myringoplasty Surgery? – Complete Overview
          </h2>
          <p className="cost">
            Cost: <span className="highlight">Rs. 45,000/-</span>
          </p>

          <div className="content">
            <p>
              Perforation of the eardrum can occur due to trauma or infection.
              Middle ear infection (Otitis Media) often leads to a perforated
              eardrum.
            </p>
            <p>
              A perforated eardrum causes hearing loss and allows infections to
              travel from the external ear to the middle ear.
            </p>
            <p>
              Frequent colds and water entering the ear are common causes of ear
              discharge. Every time discharge occurs, bacterial toxins can enter
              the inner ear, leading to sensorineural hearing loss, which is
              permanent.
            </p>
            <p>
              A persistent eardrum perforation must be repaired surgically
              through Myringoplasty (Myringo - eardrum, Plasty - repair).
            </p>
            <p>
              Myringoplasty is a surgical procedure to repair a hole in the eardrum (tympanic membrane). It helps restore hearing, prevent infections, and improve ear health.
            </p>
            <p>
              The surgery is typically performed under local or general
              anesthesia, using a small graft to close the perforation.
              Recovery is usually quick, with minimal discomfort.
            </p>
          </div>
        </div>
      </section>
      <section className="left-right-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 px-xl-4 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <h2 className="pq-section-title">Myringoplasty Procedure – Step-by-Step Explanation</h2>
                <p className="pq-section-description">
                  In a typical Myringoplasty done by the post aural approach —
                </p>
                <ul className="pq-section-description">
                  <li>
                    Hair around the operated ear is shaved for access and for
                    dressing purposes
                  </li>
                  <li>
                    The operated part is cleaned and sterilized with Povidone
                    Iodine
                  </li>
                  <li>2 % Xylocaine with adrenaline is infiltrated</li>
                  <li>
                    A skin incision is made in the groove behind the ear and
                    skin flaps lifted
                  </li>
                  <li>Temporalis Fascia graft is harvested</li>
                  <li>Edges of the perforation are freshened</li>
                  <li>Tympanomeatal flap is elevated</li>
                  <li>
                    Graft is placed in the ear over self-absorbing gelatin
                    sponge in the middle ear
                  </li>
                  <li>Ear pack is applied</li>
                  <li>
                    Wound is closed – usually subcuticular sutures are applied
                  </li>
                  <li>Mastoid bandage is applied</li>
                </ul>
              </div>
            </div>

            <div className="col-xl-6 pe-xl-5">
              <img
                src={Audio1}
                className="img-fluid wow fadeInLeft"
                alt="home"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="left-right-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 pe-xl-5">
              <img
                src={Audio2}
                className="img-fluid wow fadeInLeft"
                alt="home"
              />
            </div>
            <div className="col-xl-6 px-xl-4 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <h2 className="pq-section-title">Post-Operative Care After Eardrum Repair Surgery</h2>
                <p className="pq-section-description">
                  The mastoid bandage is usually removed on day 5
                </p>
                <p className="pq-section-description">
                  Aural pack is removed 10-14 days later
                </p>
                <p className="pq-section-description">
                  Neomembrane formation typically takes about 4-6 weeks
                </p>
              </div>

              <div className="pq-section pq-style-1 text-left mt-4">
                <h6 className="pq-section-title">Care during Post Op period</h6>
                <ul className="pq-section-description">
                  <li>Ear must be kept dry</li>
                  <li>Treat a cold immediately</li>
                  <li>Avoid air travel for about 3-4 weeks</li>
                  <li>
                    Inform doctor immediately in case of Facial weakness/
                    Paralysis including incomplete eye closure, giddiness,
                    Tinnitus (buzzing in ears), Nausea / Vomiting
                  </li>
                  <li>Do not blow your nose vigorously</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <AboutDoctor />

      <section className="left-right-section">
        <div className="container">
          <div className="row">
            <div className="col-xl-6 px-xl-4 mt-4 mt-xl-0">
              <div className="pq-section pq-style-1 text-left">
                <h2 className="pq-section-title">
                  Anaesthesia & Safety in Eardrum Repair Surgery
                </h2>
                <ul className="pq-section-description">
                  <li>
                    <strong>Local Anaesthesia</strong> – Injection of Local
                    Anaesthetic into the ear and surrounding tissues.
                  </li>
                  <li>
                    <strong>MAC – Monitored Anaesthesia Care</strong> – Patient
                    is not intubated, the Anaesthetist gives sedation and pain
                    medication via an Intra Venous route.
                  </li>
                  <li>
                    <strong>General Anaesthesia</strong> – full GA.
                  </li>
                </ul>
                <p className="pq-section-description">
                  The decision is taken depending upon the patient’s and the
                  surgeon’s preference as well as on other medical factors.
                </p>
              </div>

              <div className="pq-section pq-style-1 text-left mt-4">
                <h2 className="pq-section-title">
                  Risks & Complications of Myringoplasty Surgery
                </h2>
                <p className="pq-section-description">
                  Though generally safe and well tolerated, there are some
                  complications of the procedure:
                </p>
                <ul className="pq-section-description">
                  <li>Graft rejection</li>
                  <li>Residual perforation</li>
                  <li>Facial nerve damage</li>
                  <li>Hearing loss</li>
                  <li>Tinnitus</li>
                  <li>Giddiness, etc.</li>
                </ul>
              </div>
            </div>

            <div className="col-xl-6 pe-xl-5">
              <img
                src={Audio3}
                className="img-fluid wow fadeInLeft"
                alt="home"
              />
            </div>
          </div>
        </div>
      </section>

      <section className="myringoplasty-section">
        <div className="container">
          <h2 className="section-title text-center">
            Myringoplasty with Insurance & Health Policy Support
          </h2>

          <div className="content">
            <p>
              MedFirst ENT Centre is dedicated to providing a seamless
              experience for patients seeking ENT-related medical care, with
              affiliations with major insurance companies to facilitate the
              financial aspects of treatment, including{" "}
              <strong>myringoplasty</strong>. Their exceptional Third Party
              Administrator (TPA) team ensures an efficient and stress-free
              health claim process, whether for Group Health Insurance Plans,
              Individual/Family Health Insurance Plans, or procedures like{" "}
              <strong>myringoplasty</strong>. This commitment to streamlining
              insurance-related processes underscores their dedication to
              patient care and convenience.
            </p>

            <p>
              Understanding how health insurance policies and TPAs can assist in
              covering
              <strong>myringoplasty</strong> costs is vital when considering
              this surgical procedure to correct a deviated nasal septum.
              MedFirst advises proactive measures, including a comprehensive
              insurance policy review and choosing an ENT clinic within the
              insurance network that specializes in{" "}
              <strong>myringoplasty</strong>. Collaboration with the TPA
              streamlines claims processing, providing a confident and
              cost-effective <strong>myringoplasty</strong> experience, ensuring
              patients can breathe easier, both physically and financially.
            </p>

            <p>
              There is no other cure for a persistent perforation of the ear
              drum – it can only be repaired surgically.
            </p>
          </div>
        </div>
      </section>

      <FAQData />
    </>
  );
};

export default BestServices;
